<template>
    <div id="talk-publish">
        <van-nav-bar
                left-text="取消"
                right-text="发布"
                @click-left="$router.go(-1)"
                @click-right="onPublish"
        >
        </van-nav-bar>

        <!-- <div class="navigation">
          <span class="navigation-left">取消</span>
          <span class="navigation-right">发布</span>
        </div> -->
        <van-cell-group id="content">
            <van-field v-model="form.content" type="textarea" :autosize="{ maxHeight: 250, minHeight: 80 }" placeholder="说说你的心情吧..." />
        </van-cell-group>
        <div class="album"> 
            <img v-for="(image, key) in form.album" :key="key" v-lazy="image + '?imageView2/1/w/200/h/200'" @click="onDelete(key)"/>
            <span class="play" v-if="form.video"><i class="iconfont icon-bofang1"></i></span>
            <!-- <van-uploader :after-read="onAdd" multiple accept="image/*, video/*"> -->
            <img src="http://img.tutubox.cn/talk-add@2x.png?imageView2/1/w/200/h/200"  @click="uploadImg" v-if="form.album.length<9"/>
            <!-- </van-uploader> -->
        </div>

        <van-popup v-model="addChooseImageShow" position="bottom" >
            <div class="popup-content">
                <van-uploader :after-read="onAdd" multiple accept='image/*'> 
                  <div class="popup-first">上传照片</div>
                </van-uploader>

                <div  class="popup-second"> 
                  <upload-video @receptionVframe="receptionVframe"></upload-video>
                </div> 

                <div @click="addChooseImageShow = false" class="popup-third">取消</div>
            </div>   
        </van-popup>
    </div>
</template>

<script>
  import * as qiNiu from 'qiniu-js';
  import HtmlImageCompress from '@/utils/HtmlImageCompress';
  import {NavBar, CellGroup, Field, Lazyload, Uploader, Toast, Dialog, Popup} from 'vant';
  import UploadVideo from '@/components/UploadVideo'
  const LazyloadOptions = {
    // loading: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/20/h/200',
    // // error: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/100/h/100',
    // preload: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/200/h/200',
    loading: 'http://img.tutubox.cn/yuanquanwenzi.jpg?imageView2/1/w/200/h/200',
        // error: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/100/h/100',
        // preload: 'http://img.tutubox.cn/talk-sitg1.png?imageView2/1/w/200/h/200',
    preload: 'http://img.tutubox.cn/yuanquanwenzi.jpg?imageView2/1/w/200/h/200'
  };
  import Vue from 'vue'
  Vue.use(NavBar).use(CellGroup).use(Field).use(Lazyload, LazyloadOptions).use(Uploader).use(Toast).use(Dialog).use(Popup);

  export default {
    name: 'TalkPublish',

    components: { UploadVideo },

    data() {
      return {
        form: {
          content: '',
          album: [],
          video:''
        },
        queueUpload: [],
        addChooseImageShow: false,
        // thumbnail: false

      };
    },


    methods: {
      uploadImg() {
        if(this.form.album.length > 0) {
          Toast('已经上传成功了~');
          return
        }
        this.addChooseImageShow = true
      },

      onPublish() {
        // if (!this.form.content.length) {
        //   Toast('心情不能为空哦~');
        //   return;
        // }
        if (this.form.content.length > 250) {
          Toast('心情不能超过250字哦~');
          return;
        }
        if (!this.form.album.length) {
          Toast('至少需要上传一张图片~');
          return;
        }
        this.$http.post('/api/talk/create', this.form).then(() => {
          Toast('发布成功~');
          this.form.content = '';
          this.form.album = [];
          this.form.video = '';
          this.queueUpload = [];
          //兼容小程序得web-view
          if(window.__wxjs_environment === 'miniprogram') {
            this.$router.replace('/wxapp');
            return
          }
          this.$router.replace('/community');
        });
      },
      onDelete(key) {
        if(this.form.video) {
          Dialog.confirm({
              message: '确认删除视频?'
          }).then(() => {
            this.form.album.splice(key, 1);
            this.form.video = ''
          }).catch(() => {
          })
        }else {
          Dialog.confirm({
            message: '确认删除图片?'
          }).then(() => {
            this.form.album.splice(key, 1);
            this.queueUpload.splice(key, 1);
          }).catch(() => {
          });
        }
        
      },
      onAdd(files) {
        (Array.isArray(files) ? files : [files]).forEach((file) => {
          let exist = false;
          this.queueUpload.forEach((_item) => {
            if (file.file.name === _item.name) {
              exist = true;
              return false;
            }
          });
          if (!exist) {
            let task = {
              index: 0,
              name: file.file.name,
              status: 0,//0加入，1正在上传， 2完成上传
              url: '',
              file: file
            };
            let index = this.queueUpload.push(task);
            this.queueUpload[index - 1].index = index;
            task.index = index;   
          }
        });
        // console.log(this.queueUpload);
        this.onQueue();
      },

      onQueue() {
        // this.queueUpload.forEach(task => {
        //     if (task.status === 0) {
        //         this.upload(task, task.file);
        //         return false;
        //     }
        // })
        let task = this.queueUpload.shift();
        if(task && task.index>9) {
          task = false;
          Toast('最多只能上传9张~');
        }
        if(task) {
          this.upload(task, task.file);
          
          Toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '上传中...'
          })
        }else {
          Toast.clear();
          this.addChooseImageShow = false
        }
      },

      upload(task, file) {
       
        if (task.status !== 0)
          return;
        task.status = 1;
        let htmlImageCompress = new HtmlImageCompress(file.content, {width: 1920, quality: 0.7});
        htmlImageCompress.then((result) => {
          // this.onQueue();
          
          this.$store.dispatch('RefreshQiNiu').then(config => {
            
            let subscription = qiNiu.upload(result.blob, config.key, config.token, {
              params: {
                userId: this.$store.state.userInfo.userId,
                type: 'talk'
              }
            }, {
              useCdnDomain: true,
              region: qiNiu.region.z2
            }).subscribe(total => {
            }, error => {
              Toast('上传错误,请重试');
              console.log(error);
            }, response => {
              // Toast('上传成功');
              // console.log(response);
              task.status = 2;
              task.url = `${config.domain}/${config.key}`;
              // console.log(task);
              this.form.album.push(task.url);
              this.onQueue();
            });
            // subscription.unsubscribe() // 上传取消
          });
        }).catch((err) => {
          // 处理失败会执行
          this.queueUpload.splice(task.index - 1, 1);
          Toast('处理图像异常了,请重试~');
          console.log(err);
        });
      },

      receptionVframe(vframe, video) {
        this.addChooseImageShow = false
        // this.thumbnail = true
        this.form.album.push(vframe)
        this.form.video = video
      }
    }
  };
</script>

<style scoped lang="less">
  

    #talk-publish {
      background-color: #fff;
        /deep/ .van-nav-bar {
            border-bottom: 1px solid #eee;
        }
        /deep/ .van-nav-bar__left .van-nav-bar__text {
            color: black;
            font-size: 16px;
        }
        /deep/ .van-nav-bar__right .van-nav-bar__text {
            color: #e9aea8;
            font-size: 16px;
        }
        // .navigation{
        //     position: relative;
        //     z-index: 999;
        //     border-bottom: 1px solid #eee;
        //     height: 45px;
        //     line-height: 45px;
        //     .navigation-left{
        //       position: absolute;
        //       left: 10px;
        //       color: black;
        //       font-size: 16px;
        //     }
        //     .navigation-right{
        //       position: absolute;
        //       right: 10px;
        //       color: #bea473;
        //       font-size: 16px;
        //     }
        // }
        #content /deep/ [class*=van-hairline]::after {
            content: none;
        }
        .album {
            display: flex;
            justify-content: left;
            flex-flow: row wrap;
            padding: 0 15px;
            position: relative;
            > img {
                margin-right: 4px;
                margin-bottom: 4px;
                width: 100px;
                height: 100px;
            }
            .play{
              position: absolute;
              top: 28px;
              left: 43px;
              .iconfont{
                font-size: 40px;
                color: #fff;
              }
            }
        }

        /deep/ [class*=van-hairline]::after {
            border: none;
        }
         .popup-content{
            div{
                text-align: center;
                height: 50px;
                line-height: 50px;
                width: 100%;
                background-color: #fff;
                font-size: 18px;
            }
            .popup-first{
                border-bottom: 1px solid #dad5db;
            }
            .popup-second{
                border-bottom: 5px solid #dad5db;
            }
        }
    }
</style>


